import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import './DnsWidget.scss';
import { TableWidget } from '../table-widget/TableWidget';
import { DnsGraphs } from '../Dns-graphs/DnsGraphs';
import CustomBreadcrumbs from '../breadcrumbs/Breadcrumbs';
import { MonitorSmartphone, Router } from 'lucide-react';

type Props = {
  type: string; // all -> operatorDns  router -> routerDns  device -> deviceDns
  deviceId?: any; // Need for device
  haanndleId?: any; // need for haanndle and device
  category?: string;
  page: string; // main -> all three  secondary -> router and device page
};

export const DnsWidget = (props: Props) => {
  const { operatorId } = useParams();
  const { t } = useTranslation();
  const [selectedRange, setSelectedRange] = useState<string>('1d');
  const [breadcrumbHeader, setBreadcrumbHeader] = useState<string>('');
  const [tableUrl, setTableUrl] = useState<string>();
  const [checkboxSelected, setcheckboxSelected] = useState<string>('1d');
  const [startDateQuery, setStartDateQuery] = useState<string>('');
  const [endDateQuery, setEndDateQuery] = useState<string>('');
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [isAllFilled, setIsAllFilled] = useState<boolean>(false);
  const [showBackBtn, setShowBackBtn] = useState<boolean>(false);
  const [deviceSearch, setDeviceSearch] = useState<string>('');
  const [selectedCategory, setSelectedCategory] = useState<string>();
  const [cpeSearch, setCpeSearch] = useState<string>('');
  const [urlSearch, setUrlSearch] = useState<string>('');
  const [accountSearch, setAccountSearch] = useState<string>('');

  const [urlClicked, setUrlClicked] = useState<boolean>(false);

  const [deviceId, setDeviceId] = useState<any>();
  const [cpeId, setCpeId] = useState<any>();

  const [reloadKey, setReloadKey] = useState<number>(0);

  const [clickedMarker, setClickedMarker] = useState();
  const [hideSites, setHideSites] = useState<boolean>(false);

  const [formData, setFormData] = useState<any>({
    startDate: '',
    startTime: '',
    endDate: '',
    endTime: '',
  });

  const [dnsRequests, setDnsRequests] = useState([{ allUniqueUrlsVisited: 0 }, { allUniqueUrlsBlocked: 0 }]);

  // useEffect(() => {
  //   // markerSearch();
  // }, [clickedMarker]);

  useEffect(() => {
    fetchDnsRequests();
  }, [checkboxSelected, selectedRange]);

  useEffect(() => {
    fetchApiTimeSearch(props.type);
  }, [formData, deviceSearch, cpeSearch]);

  useEffect(() => {
    const allFilled = Object.values(formData).every((input) => input !== '');
    setIsAllFilled(allFilled);
  }, [formData]);

  const handleMarkerClick = (marker: any) => {
    setHideSites(marker);
  };

  async function fetchDnsRequests() {
    if (props.type === 'router') {
      const response = await axios.get(
        `/v2/op/dns-records/${operatorId}/dns-count/?l=${checkboxSelected}&cpeId=${props.haanndleId}&devId=`
      );
      setDnsRequests(response.data.allDnsRequests);
    } else if (props.type === 'device') {
      const response = await axios.get(
        `/v2/op/dns-records/${operatorId}/dns-count/?l=${checkboxSelected}&cpeId=${props.haanndleId}&devId=${props.deviceId}`
      );
      setDnsRequests(response.data.allDnsRequests);
    }
  }

  // when all time inputs are filled in this function is called
  // lisens to filter inputs
  async function fetchApiTimeSearch(type: string) {
    if (isAllFilled) {
      let start = formData.startDate + ' ' + formData.startTime + '.000';
      let end = formData.endDate + ' ' + formData.endTime + '.000';

      setStartDateQuery(start);
      setEndDateQuery(end);
      setReloadKey((prevKey) => prevKey + 1);
    }
  }

  const handleCheckboxChange = (value: string) => {
    if (checkboxSelected != value) {
      setHideSites(false);
    }
    setUrlClicked(false);
    setcheckboxSelected(value);
    setStartDateQuery('');
    setEndDateQuery('');
    setIsAllFilled(false);
    setReloadKey((prevKey) => prevKey + 1);
    setSelectedRange(value);
  };

  const clearFilter = () => {
    setFormData({
      startDate: '',
      startTime: '',
      endDate: '',
      endTime: '',
    });
  };

  // handles all form inputs
  const handleTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData((prevState: any) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const [selectedUniqueBlockedFqdn, setSlectedUniqueBlockedFqdn] = useState<string>('');

  const handleUrlRowClick = async (row: any) => {
    setSelectedCategory(row.key.categories);
    setUrlSearch(row.key.FQDN);
    setUrlClicked(true);
    setShowBackBtn(true);
    setSlectedUniqueBlockedFqdn(row);
    setReloadKey((prevKey) => prevKey + 1);
    setBreadcrumbHeader('Unique Blocked FQDNs');
  };

  const handleBackButton = () => {
    setUrlClicked(false);
    setUrlSearch('');
    setShowBackBtn(false);
    setReloadKey((prevKey) => prevKey + 1);
    setSelectedCategory('');
  };

  const [dnsCards, setDnsCards] = useState<any[]>([]);

  useEffect(() => {
    const initialCrumbs: any[] = [
      {
        label: breadcrumbHeader,
        onBreadcrumbClick: () => {
          handleBackButton();
          setBreadcrumbHeader('');
        },
      },
    ];

    if (urlClicked) {
      initialCrumbs.push({
        label: urlSearch,
        onBreadcrumbClick: () => {},
      });
    }
    setDnsCards(initialCrumbs);
  }, [urlClicked, urlSearch, hideSites]);

  const rangeOptions = [
    { value: '1d', label: t('activity.range.today') },
    { value: '7d', label: t('activity.range.past7Days') },
    { value: '30d', label: t('activity.range.past30Days') },
  ];
  const blurOnEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') e.currentTarget.blur();
  };

  const nonSelected =
    'flex w-full justify-center items-center text-sm py-1 border-1 bg-[#BDCDD1] border-[#003D4C] h-[40px] font-bold text-[#10182080]';
  const selected =
    'flex w-full options justify-center items-center text-sm py-1 border-1 bg-[#53B798] border-[#003D4C] h-[40px] font-bold text-[#101820]';
  return (
    <section>
      <div className="w-full rounded-xl shadow-md retina-table p-5 dnsw">
        {props.page === 'main' && (
          <div className="dnsw-toolbar">
            <div className="dnsw-group">
              <span className="bd-field-label">{t('activity.range.historyWithin')}</span>
              <div className="bd-segmented" role="group" aria-label={t('activity.range.ariaLabel')}>
                {rangeOptions.map((range) => (
                  <button
                    key={range.value}
                    type="button"
                    className={selectedRange === range.value ? 'active' : ''}
                    aria-pressed={selectedRange === range.value}
                    onClick={() => handleCheckboxChange(range.value)}
                  >
                    {range.label}
                  </button>
                ))}
              </div>
            </div>

            {(props.type === 'all' || props.type === 'router') && (
              <div className="dnsw-group">
                <span className="bd-field-label">{t('activity.filter.filterBy')}</span>
                <div className="dnsw-filters">
                  {props.type === 'all' && (
                    <>
                      <label className="bd-search dnsw-filter">
                        <Router size={14} />
                        <input
                          type="number"
                          id="7-days-cpe"
                          placeholder="CPE"
                          aria-label={t('activity.filter.filterByCpe')}
                          onBlur={(e) => setCpeSearch(e.target.value)}
                          onKeyDown={blurOnEnter}
                        />
                      </label>
                      <span className="bd-meta">{t('activity.filter.or')}</span>
                    </>
                  )}
                  <label className="bd-search dnsw-filter">
                    <MonitorSmartphone size={14} />
                    <input
                      type="number"
                      id="7-days-device"
                      placeholder={t('activity.filter.device')}
                      aria-label={t('activity.filter.filterByDevice')}
                      onBlur={(e) => setDeviceSearch(e.target.value)}
                      onKeyDown={blurOnEnter}
                    />
                  </label>
                </div>
              </div>
            )}
          </div>
        )}
        <div className={`${hideSites ? '' : 'flex gap-8'}`}>
          {!hideSites && (
            <>
              <div style={{ borderRadius: 16 }} className="retina-table col-6 p-2 rounded-md shadow-md dnsw-blocked">
                {props.page === 'secondary' && (
                  <div>
                    <div className="flex items-center justify-between">
                      <div className="">
                        <span className="mr-3 text-xl">{t('activity.range.historyWithinColon')}</span>
                      </div>
                      <div className="flex w-[65%]">
                        <button
                          className={selectedRange === '1d' ? selected : nonSelected}
                          style={{ borderRadius: '16px 0px 0px 16px' }}
                          onClick={() => handleCheckboxChange('1d')}
                        >
                          {t('activity.range.today')}
                        </button>
                        <button className={selectedRange === '7d' ? selected : nonSelected} onClick={() => handleCheckboxChange('7d')}>
                          {t('activity.range.past7Days')}
                        </button>
                        <button
                          className={selectedRange === '30d' ? selected : nonSelected}
                          style={{ borderRadius: '0px 16px 16px 0px' }}
                          onClick={() => handleCheckboxChange('30d')}
                        >
                          {t('activity.range.past30Days')}
                        </button>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-8 mt-3 mb-3">
                      <div
                        style={{ borderRadius: 16 }}
                        className="retina-table text-center flex flex-col items-center justify-center p-2 rounded-2xl shadow-md"
                      >
                        <div className="flex items-center justify-center">
                          <span>{t('activity.widget.totalUniqueSitesVisited')}</span>
                        </div>
                        <div className="flex items-center justify-center p-3">
                          <h2>{dnsRequests[0].allUniqueUrlsVisited}</h2>
                        </div>
                      </div>

                      <div
                        style={{ borderRadius: 16 }}
                        className="retina-table text-center flex flex-col items-center justify-center p-2 rounded-2xl shadow-md"
                      >
                        <div className="flex items-center justify-center ">
                          <span className="text-red-600">{t('activity.widget.totalUniqueSitesBlocked')}</span>
                        </div>
                        <div className="flex items-center justify-center p-3">
                          <h2 className="text-red-600">{dnsRequests[1].allUniqueUrlsBlocked}</h2>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {showBackBtn && (
                  <div className="absolute top-[41%] left-[3%]">
                    <img src="/icons/arrow-prev-pag.svg" className="hover:cursor-pointer mr-10" onClick={handleBackButton} />
                  </div>
                )}
                <div className="">
                  <TableWidget
                    hasSearch={true}
                    url={`v2/op/dns-records/${operatorId}/list-records`}
                    countPerPage={5}
                    title={t('activity.widget.uniqueSitesBlocked')}
                    searchPositionRight={true}
                    hasCategoryFilter={true}
                    cpeId={cpeSearch ? [Number(cpeSearch)] : []}
                    deviceId={deviceSearch ? [Number(deviceSearch)] : []}
                    startDate={startDate}
                    endDate={endDate}
                    isDns={true}
                    needCategories={true}
                    type={'BLOCKED'}
                    urlSearch={urlSearch}
                    key={`${urlSearch}-${checkboxSelected}-${deviceId}-${cpeId}`}
                    onRowSelect={handleUrlRowClick}
                    // countSearch={"operator"}
                    selectedDate={checkboxSelected}
                  />
                </div>
              </div>
            </>
          )}

          <div className="w-full">
            {props.page === 'main' ? (
              <>
                {/* <TableWidget
                  key={reloadKey}
                  hasSearch={true}
                  url={`v2/op/dns-records/${operatorId}/operator`}
                  countPerPage={8}
                  title="DNS Activity"
                  searchPositionRight={true}
                  selectedDate={checkboxSelected}
                  startDate={startDateQuery}
                  endDate={endDateQuery}
                  hasCatagoryFilter={false}
                  isDns={true}
                  cpeId={cpeId}
                  deviceId={deviceId}
                /> */}

                <DnsGraphs
                  setMarker={handleMarkerClick}
                  selectedDate={checkboxSelected}
                  startDate={startDateQuery}
                  endDate={endDateQuery}
                  cpeId={cpeSearch}
                  deviceId={deviceSearch}
                  url={urlSearch}
                  account={accountSearch}
                  clearFilter={clearFilter}
                />
              </>
            ) : (
              <div style={{ borderRadius: 16 }} className="w-full rounded-md shadow-md">
                {urlClicked && (
                  <img src="/icons/arrow-prev-pag.svg" className="hover:cursor-pointer mr-10" onClick={handleBackButton} />
                )}
                <div className="rounded-md shadow-md">
                  <TableWidget
                    key={reloadKey}
                    hasSearch={true}
                    url={`v2/op/dns-records/${operatorId}/list-records`}
                    countPerPage={8}
                    title={t('activity.widget.dnsActivity')}
                    searchPositionRight={true}
                    selectedDate={checkboxSelected}
                    startDate={startDate}
                    endDate={endDate}
                    isDns={true}
                    type={urlClicked ? 'TIMESTAMP' : 'DNS'}
                    cpeId={props.type === 'router' ? [props.haanndleId] : []}
                    deviceId={props.type === 'router' ? [] : [props.deviceId]}
                    hasCategoryFilter={true}
                    category={selectedCategory !== '' ? selectedCategory : ''}
                    needCategories={true}
                    urlSearch={urlClicked ? urlSearch : ''}
                    onRowSelect={handleUrlRowClick}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
